import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { Middleware } from 'redux';

import reducers from 'src/reducers';

const store = configureStore({
    devTools: false,
    reducer: reducers,
    middleware: (gdm) => {
        const middlewares: Array<Middleware> = [];
        if(__DEVELOPMENT__) {
            middlewares.push(createLogger({
                duration: true,
                collapsed: true
            }) as Middleware);
        }

        return gdm().concat(middlewares);
    }
});

export default store;
